import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material/material.module';
import { ComponentsModule } from './components/components.module';
import { PipesModule } from '../pipes/pipes.module';

import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';
import { UserComponent } from './user/user.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { RouterModule } from '@angular/router';
import { MyPatientsComponent } from './my-patients/my-patients.component';
import { NoreevaluatedSidebarComponent } from './dashboard/noreevaluated-sidebar/noreevaluated-sidebar.component';

@NgModule({
  declarations: [
    PagesComponent,
    UserComponent,
    MyPatientsComponent,
    NoreevaluatedSidebarComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    DashboardModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ComponentsModule,
    PipesModule
  ],
})
export class PagesModule { }
